import { CreateMediaInputApiModel } from "@app/store/http/models/input";

export interface UpdateUserProfileInputApiModel {
    id: number;
    display_name: string;
    first_name: string;
    last_name: string;
    avatar: CreateMediaInputApiModel;
    slug: string;
    email: string;
    profile_twitter: string;
    profile_linkedin: string;
    profile_facebook: string;
    work_purpose: string;
    work_location: string;
    title: string;
    work_attributes: any;
    follow_enable: boolean;
    public: boolean;
    story_invite_enable: boolean;
    name_public: boolean;
    bg_header:CreateMediaInputApiModel;
}
